import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";

/**
 * platform.eon.health is sales-led in v1. /signup intentionally does NOT
 * self-serve account creation — every new Organization is created by EON
 * via Django admin and the owner receives an accept-invite email.
 *
 * This page is the redirect target for inbound /signup traffic.
 */
export function SignupRedirect() {
  return (
    <div className="w-full max-w-[460px] anim-fade-up">
      <div
        className="rounded-[var(--radius-modal)] p-8 shadow-xl-eon"
        style={{
          background: "rgba(11, 13, 18, 0.55)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(36px) saturate(180%)",
          WebkitBackdropFilter: "blur(36px) saturate(180%)",
        }}
      >
        <p className="font-mono text-[11px] uppercase tracking-[0.06em] text-[var(--color-slate-200)]">
          Platform
        </p>
        <h1 className="mt-1 text-heading text-[var(--color-snow)] font-semibold">
          Let's talk first
        </h1>
        <p className="mt-3 text-[14px] text-[var(--color-slate-200)] leading-relaxed">
          EON's brand platform is sales-led — we onboard each organization by hand
          so we can shape the program, review the prompt overlay, and align on
          data-sharing. It takes about a week from intro call to first cohort live.
        </p>

        <div className="mt-6 grid gap-3">
          <a
            href="mailto:platform@eon.health?subject=Platform%20Trial"
            className="block"
          >
            <Button size="lg" className="w-full">
              Email platform@eon.health
            </Button>
          </a>
          <Link to="/signin" className="block">
            <Button variant="outlined" size="lg" className="w-full">
              I already have an account
            </Button>
          </Link>
        </div>

        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.06em] text-[var(--color-slate-300)]">
          Looking for the consumer app? eon.health
        </p>
      </div>
    </div>
  );
}
